import VueI18n from 'vue-i18n'
import Vue from 'vue'
import enMessages from './en_US'
import esMessages from './es_MX'
import numberFormats from './number-formats'

Vue.use(VueI18n)
const i18nMessages = {
  en: enMessages,
  en_US: enMessages,
  es: esMessages,
  es_MX: esMessages
}

const parseParamsFromSearch = () => {
  const search = window.location.search.split('=')
  search[0] = search[0].substring(1)
  return search
}

const parseParamsFromHash = () => {
  const hash = window.location.hash
  return hash.substring(hash.indexOf('?') + 1).split('=')
}

const bestGuessLocale = () => {
  const segs =
    window.location.search.length > 0
      ? parseParamsFromSearch()
      : parseParamsFromHash()
  const parameter = segs[0]
  if (parameter === 'localeOverride') {
    const localeOverride = segs[1]
    return localeOverride
  }
  if (navigator.languages && navigator.languages[0]) {
    return navigator.languages[0]
  }
  return navigator.language
}

const localeOverride = bestGuessLocale()

const i18n = new VueI18n({
  locale: localeOverride || 'en',
  fallbackLocale: 'en',
  messages: i18nMessages,
  numberFormats,
  silentTranslationWarn: true
})

export default i18n
